import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { IntegrationUXService } from './components/Service'
import { IntegrationUXUI } from './components/UI'
import classes from './IntegrationUX.module.scss'

export default function IntegrationUXPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags
        title={'Integration UX'}
        description={
          'User interface is the hardest part of building native integrations. We make it simple.'
        }
      />
      <Container>
        <IntegrationUXService />
        <IntegrationUXUI />
      </Container>
    </DefaultPageLayout>
  )
}
